import React from 'react'
import PropTypes from 'prop-types'
import { Motion, spring } from 'react-motion'
import { MdClose, MdMoreHoriz, MdShare, MdReport } from 'react-icons/md'
import ReportModal from './Report/ReportModal'
import { isMobile } from 'react-device-detect'
import MessageModal from './Message/MessageModal'
import ShareButton from '../../../../components/shared/SocialShare/ShareButton'
import { bindActionCreators, compose } from 'redux'
import * as actionsNotification from '../../../../actions/notification'
import { connect } from 'react-redux'
import storeService from '../../../../api/services/storeService'
import Fingerprint2 from 'fingerprintjs2'
import isArray from 'lodash/isArray'
import isString from 'lodash/isString'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
  Container,
  Label,
  ActionItem,
  Menu,
  Overlay,
  ActionButton,
  ButtonDots,
  ShareIcon,
  ButtonShareCircle,
  ButtonShare,
  ReportActionItem
} from './ActionButtonsStyledComponents'
import { withRouter } from 'react-router-dom'
import { FaQrcode } from 'react-icons/fa'
import StoreThemeProvider from '../../StoreThemeProvider/StoreThemeProvider'

class ActionButtons extends React.PureComponent {
  static propTypes = {
    toggleShareModal: PropTypes.func,
    onToggle: PropTypes.func,
    intl: PropTypes.object.isRequired,
    activeStore: PropTypes.object.isRequired,
    actionsNotification: PropTypes.object,
    history: PropTypes.object,
    isZeroTouch: PropTypes.bool,
    isMobile: PropTypes.bool
  }

  constructor () {
    super()

    this.state = {
      isActive: false,
      isOpenReportModal: false,
      isOpenMessageModal: false
    }

    // Fingerprint2.getV18({}, result => {
    //   this.buyer_device_id = result
    // })
    const fpInstance = new Fingerprint2()
    fpInstance.get(result => {
      this.buyer_device_id = result
    })
  }

  toggleActive = () => {
    this.props.onToggle && this.props.onToggle(!this.state.isActive)
    this.setState({ isActive: !this.state.isActive })
  }

  toggleReportModal = () => {
    this.setState({ isOpenReportModal: !this.state.isOpenReportModal })
  }

  onSubmitReportModal = async value => {
    const { intl, activeStore } = this.props
    try {
      await storeService.reportStore(
        activeStore._id,
        value,
        this.buyer_device_id || 'error-generating-device-id'
      )
      this.props.actionsNotification.showNotification({
        title: intl.formatMessage({ id: 'info.report.title' }),
        type: 'info',
        message: intl.formatMessage({ id: 'info.report.message' })
      })
      this.toggleReportModal()
      this.setState({ isActive: false })
    } catch (resp) {
      let error = ''
      const response = resp.response.data.response
      if (response) {
        if (isArray(response)) {
          error = response.reduce((acc, item) => acc + item, error)
        } else if (isString(response)) {
          error = response
        }
      }
      this.props.actionsNotification.showNotification({
        title: 'Error while sending report',
        type: 'error',
        message: `Your report was not sent. ${error}`
      })
    }
  }

  toggleMessageModal = () => {
    this.setState({ isOpenMessageModal: !this.state.isOpenMessageModal })
  }

  onSubmitMessageModal = value => {
    this.toggleMessageModal()
    this.setState({ isActive: false })
  }

  onShareViaQr = () => {
    const { activeStore } = this.props
    const itemId = activeStore.getShortId()
    this.props.history.push(`/qr?storeId=${itemId}`)
  }

  render () {
    const { activeStore } = this.props
    const { isActive } = this.state
    const storeName = activeStore.getName()
    const storeId = activeStore.getShortId()
    const storeSocialPhoto = activeStore.getSocialPhotos()
    const description = activeStore.getDescription()
    const storeUrl = activeStore.getOwnUrl()
    return (
      <StoreThemeProvider store={activeStore}>
        <Container>
          {!isMobile ? (
            <ShareButton
              onToggle={toggled => {
                this.props.toggleShareModal &&
                  this.props.toggleShareModal(toggled)
              }}
              itemUrl={storeUrl}
              itemName={storeName}
              description={description}
              itemId={storeId}
              socialPhotos={storeSocialPhoto}
            >
              <ButtonShare>
                <ShareIcon />
                <FormattedMessage id='store.actions.share.share' />
              </ButtonShare>
            </ShareButton>
          ) : (
            <ShareButton
              onToggle={toggled => {
                this.props.toggleShareModal &&
                  this.props.toggleShareModal(toggled)
              }}
              itemUrl={storeUrl}
              itemName={storeName}
              description={description}
              itemId={storeId}
              socialPhotos={storeSocialPhoto}
            >
              <ButtonShareCircle className='btn-circle' ismobile={isMobile.toString()}>
                <ShareIcon />
              </ButtonShareCircle>
            </ShareButton>
          )}
          <div style={{ position: 'relative' }}>
            <ButtonDots
              onClick={this.toggleActive}
              ismobile={isMobile}
              className='action-buttons__button btn-circle'
            >
              {this.state.isActive ? <MdClose /> : <MdMoreHoriz />}
            </ButtonDots>
            <Motion
              defaultStyle={{
                opacity: 0,
                x1: -40,
                x2: -80,
                x3: -120
              }}
              style={{
                opacity: spring(isActive ? 1 : 0, {
                  stiffness: 600,
                  damping: 60
                }),
                x1: spring(isActive ? 0 : -40, { stiffness: 400, damping: 50 }),
                x2: spring(isActive ? 0 : -80, { stiffness: 400, damping: 50 }),
                x3: spring(isActive ? 0 : -120, { stiffness: 400, damping: 50 })
              }}
            >
              {style => (
                <React.Fragment>
                  {(style.opacity !== 0 || isActive) && (
                    <Menu>
                      <ActionItem
                        onClick={this.toggleReportModal}
                        style={{
                          transform: isMobile ? `translateY(${style.x3}px)` : `translateX(${style.x3}px)`,
                          opacity: style.opacity
                        }}
                      >
                        <Label className='btn-white'>
                          <FormattedMessage id={this.props.isZeroTouch ? 'store.actions.reportMenu' : 'store.actions.reportHausmart'} />
                        </Label>
                        <ActionButton className='btn-white btn-circle-sm'>
                          <MdReport />
                        </ActionButton>
                      </ActionItem>
                      <ActionItem
                        onClick={this.onShareViaQr}
                        style={{
                          transform: isMobile ? `translateY(${style.x3}px)` : `translateX(${style.x3}px)`,
                          opacity: style.opacity
                        }}
                      >
                        <Label className='btn-white'>
                          <FormattedMessage id='store.actions.shareViaQR' />
                        </Label>
                        <ActionButton className='btn-white btn-circle-sm'>
                          <FaQrcode color='black' size='16px' />
                        </ActionButton>
                      </ActionItem>
                      <ShareButton
                        onToggle={toggled => {
                          this.props.toggleShareModal &&
                            this.props.toggleShareModal(toggled)
                        }}
                        itemUrl={storeUrl}
                        itemName={storeName}
                        description={description}
                        itemId={storeId}
                        socialPhotos={storeSocialPhoto}
                      >
                        <ReportActionItem
                          style={{
                            transform: isMobile ? `translateY(${style.x2}px)` : `translateX(${style.x2}px)`,
                            opacity: style.opacity
                          }}
                        >
                          <Label className=' btn-white'>
                            <FormattedMessage id='store.actions.shareHausmart' />
                          </Label>
                          <ActionButton className='btn-white btn-circle-sm'>
                            <MdShare />
                          </ActionButton>
                        </ReportActionItem>
                      </ShareButton>
                    </Menu>
                  )}
                  {(style.opacity !== 0 || isActive) && (
                    <Overlay
                      style={{ opacity: style.opacity }}
                      onClick={() => style.opacity === 1 && this.toggleActive()}
                    />
                  )}
                </React.Fragment>
              )}
            </Motion>
          </div>
          <ReportModal
            storeName={storeName}
            isOpen={this.state.isOpenReportModal}
            toggle={this.toggleReportModal}
            onSubmit={this.onSubmitReportModal}
          />
          <MessageModal
            storeName={storeName}
            isOpen={this.state.isOpenMessageModal}
            toggle={this.toggleMessageModal}
            onSubmit={this.onSubmitMessageModal}
          />
        </Container>
      </StoreThemeProvider>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeStore: state.activeStore
  }
}

const mapDispatchToProps = dispatch => ({
  actionsNotification: bindActionCreators(actionsNotification, dispatch)
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(ActionButtons)
export { ActionButtons }
